/* FlightTrackerLED custom homepage — progressive enhancement.
   All DOM work deferred until DOM ready so module order is safe. */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  ready(function () {
    setupNavToggle();
    renderBarcodes();
    renderBagTags();
    renderTicker();
    setupLEDBoard();
    setupCalloutCarousel();
  });

  function setupCalloutCarousel() {
    const carousel = document.querySelector('[data-carousel]');
    if (!carousel) return;
    const track = carousel.querySelector('[data-carousel-track]');
    const slides = track ? track.children : [];
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    const dots = carousel.querySelectorAll('[data-carousel-dot]');
    if (!track || !slides.length) return;

    let index = 0;
    const update = () => {
      track.style.transform = `translateX(${-index * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    };
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      update();
    };

    prevBtn && prevBtn.addEventListener('click', () => go(index - 1));
    nextBtn && nextBtn.addEventListener('click', () => go(index + 1));
    dots.forEach((d) =>
      d.addEventListener('click', () => go(parseInt(d.dataset.carouselDot, 10)))
    );

    let startX = null;
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  /* ---------- Mobile nav toggle ---------- */
  function setupNavToggle() {
    const nav = document.getElementById('site-nav');
    const btn = nav && nav.querySelector('.nav-toggle');
    if (!nav || !btn) return;

    btn.addEventListener('click', () => {
      const open = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', String(!open));
      btn.setAttribute('aria-expanded', String(!open));
    });

    nav.querySelectorAll('.nav-links a').forEach((link) => {
      link.addEventListener('click', () => {
        nav.setAttribute('data-open', 'false');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Step-tag barcodes ---------- */
  function renderBarcodes() {
    const widths = [2, 1, 3, 1, 2, 1, 1, 2, 3, 1, 2, 1, 3, 2, 1, 1, 2, 3, 1, 2, 1, 1, 3, 2, 1];
    ['bc1', 'bc2', 'bc3', 'bc4'].forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      const frag = document.createDocumentFragment();
      widths.forEach((w) => {
        const bar = document.createElement('span');
        bar.style.width = w + 'px';
        frag.appendChild(bar);
      });
      el.appendChild(frag);
    });
  }

  /* ---------- Vintage airline bag-tag wall ---------- */
  function renderBagTags() {
    const wall = document.getElementById('tagWall');
    if (!wall) return;

    const tags = [
      { code: 'LAX', city: 'Los Angeles', airline: 'PAN AMERICAN', sub: 'WORLD AIRWAYS', style: 'solid', bg: '#1b3a7a', text: '#fff', accent: '#c8d8f0', size: 96, r: -8 },
      { code: 'JFK', city: 'New York', airline: 'TRANS WORLD', sub: 'AIRLINES', style: 'split', bg: '#c93525', bg2: '#fff', text: '#fff', text2: '#c93525', accent: '#fff', size: 88, r: 11 },
      { code: 'ORD', city: 'Chicago', airline: 'UNITED', sub: 'AIR LINES', style: 'stripe', bg: '#1a3a6b', stripe: '#e8c13a', text: '#fff', accent: '#e8c13a', size: 80, r: -5 },
      { code: 'DFW', city: 'Dallas', airline: 'AMERICAN', sub: 'AIRLINES', style: 'border', bg: '#fff', border: '#c93525', text: '#c93525', accent: '#1a1209', size: 84, r: 7 },
      { code: 'MIA', city: 'Miami', airline: 'BRANIFF', sub: 'INTERNATIONAL', style: 'solid', bg: '#e06820', text: '#fff', accent: '#ffe0b0', size: 92, r: -12 },
      { code: 'ATL', city: 'Atlanta', airline: 'EASTERN', sub: 'AIR LINES', style: 'split', bg: '#2155a0', bg2: '#e0e8f8', text: '#fff', text2: '#2155a0', accent: '#e0e8f8', size: 78, r: 9 },
      { code: 'BOS', city: 'Boston', airline: 'DELTA', sub: 'AIR LINES', style: 'border', bg: '#f0f4ff', border: '#c93525', text: '#c93525', accent: '#1a1209', size: 86, r: -6 },
      { code: 'IAH', city: 'Houston', airline: 'CONTINENTAL', sub: 'AIRLINES', style: 'solid', bg: '#b89020', text: '#fff', accent: '#fff5cc', size: 82, r: 14 },
      { code: 'SEA', city: 'Seattle', airline: 'WESTERN', sub: 'AIRLINES', style: 'stripe', bg: '#1a1209', stripe: '#c93525', text: '#fff', accent: '#c93525', size: 88, r: -9 },
      { code: 'SFO', city: 'San Francisco', airline: 'NATIONAL', sub: 'AIRLINES', style: 'solid', bg: '#c85820', text: '#fff', accent: '#ffd0a0', size: 76, r: 6 },
      { code: 'CLT', city: 'Charlotte', airline: 'PIEDMONT', sub: 'AIRLINES', style: 'border', bg: '#e8f0ff', border: '#2d5fa0', text: '#2d5fa0', accent: '#1a1209', size: 80, r: -11 },
      { code: 'DEN', city: 'Denver', airline: 'FRONTIER', sub: 'AIRLINES', style: 'solid', bg: '#2a6b3c', text: '#fff', accent: '#a0ffb0', size: 84, r: 8 },
      { code: 'LAS', city: 'Las Vegas', airline: 'HUGHES', sub: 'AIRWEST', style: 'split', bg: '#d4a800', bg2: '#1a1209', text: '#1a1209', text2: '#d4a800', accent: '#fff', size: 90, r: -4 },
      { code: 'PHL', city: 'Philadelphia', airline: 'MOHAWK', sub: 'AIRLINES', style: 'solid', bg: '#8b1a1a', text: '#fff', accent: '#ffaaaa', size: 76, r: 10 },
      { code: 'SAN', city: 'San Diego', airline: 'PSA', sub: 'PACIFIC SOUTHWEST', style: 'stripe', bg: '#e03030', stripe: '#ff9900', text: '#fff', accent: '#fff', size: 88, r: -7 },
      { code: 'SNA', city: 'Orange County', airline: 'AIR CALIFORNIA', sub: '', style: 'border', bg: '#fff8e8', border: '#d06000', text: '#d06000', accent: '#1a1209', size: 80, r: 12 },
      { code: 'STL', city: 'St. Louis', airline: 'OZARK', sub: 'AIR LINES', style: 'solid', bg: '#4a72c4', text: '#fff', accent: '#c0d0ff', size: 82, r: -10 },
      { code: 'MSY', city: 'New Orleans', airline: 'SOUTHERN', sub: 'AIRWAYS', style: 'split', bg: '#1a5c2a', bg2: '#f5f0e0', text: '#fff', text2: '#1a5c2a', accent: '#f5f0e0', size: 86, r: 5 },
      { code: 'ANC', city: 'Anchorage', airline: 'ALASKA', sub: 'AIRLINES', style: 'solid', bg: '#00468b', text: '#fff', accent: '#8ec8ff', size: 78, r: -13 },
      { code: 'HNL', city: 'Honolulu', airline: 'ALOHA', sub: 'AIRLINES', style: 'stripe', bg: '#d4600a', stripe: '#e8c13a', text: '#fff', accent: '#ffe0a0', size: 92, r: 9 },
    ];

    const placements = [
      { x: 1, y: 6, r: -12 }, { x: 7, y: 1, r: 8 }, { x: 13, y: 3, r: -6 }, { x: 21, y: 0, r: 11 },
      { x: 30, y: 2, r: -4 }, { x: 38, y: 5, r: 7 }, { x: 70, y: 2, r: -10 }, { x: 79, y: 0, r: 9 },
      { x: 87, y: 4, r: -7 }, { x: 93, y: 10, r: 13 },
      { x: 1, y: 28, r: 9 }, { x: 4, y: 50, r: -11 }, { x: 2, y: 68, r: 6 }, { x: 3, y: 82, r: -8 },
      { x: 92, y: 30, r: 10 }, { x: 91, y: 52, r: -9 }, { x: 90, y: 68, r: 12 }, { x: 88, y: 82, r: -11 },
      { x: 15, y: 90, r: -5 }, { x: 28, y: 94, r: 8 },
    ];

    const frag = document.createDocumentFragment();

    tags.forEach((t, i) => {
      const p = placements[i] || { x: Math.random() * 90, y: Math.random() * 90, r: (Math.random() - 0.5) * 20 };

      let bodyStyle = '';
      let innerOverlay = '';

      if (t.style === 'solid') {
        bodyStyle = `background:${t.bg};color:${t.text};`;
      } else if (t.style === 'split') {
        bodyStyle = `background:linear-gradient(135deg, ${t.bg} 50%, ${t.bg2} 50%);color:${t.text};`;
      } else if (t.style === 'border') {
        bodyStyle = `background:${t.bg};color:${t.text};border-color:${t.border}!important;border-width:3px!important;`;
      } else if (t.style === 'stripe') {
        bodyStyle = `background:repeating-linear-gradient(45deg, ${t.bg} 0px, ${t.bg} 4px, ${t.stripe} 4px, ${t.stripe} 8px);color:${t.text};`;
        innerOverlay = `<div style="position:absolute;inset:0;border-radius:4px 4px 8px 8px;background:${t.bg};opacity:0.88;z-index:0;"></div>`;
      }

      const tagNum = `${String.fromCharCode(65 + (i % 26))}${Math.floor(Math.random() * 9 + 1)}-${String(Math.floor(Math.random() * 9000 + 1000))}`;

      const tagEl = document.createElement('div');
      tagEl.className = 'bag-tag';
      tagEl.setAttribute('aria-hidden', 'true');
      tagEl.style.cssText = `left:${p.x}%;top:${p.y}%;transform:rotate(${p.r}deg);width:${t.size}px;opacity:0.88;`;
      tagEl.innerHTML = `
        <div class="tag-string" style="background:#a08060;"></div>
        <div class="tag-hole" style="background:${t.bg};border:2px solid rgba(0,0,0,0.3);width:12px;height:12px;border-radius:50%;flex-shrink:0;margin:0 auto;"></div>
        <div class="tag-body" style="${bodyStyle}position:relative;overflow:hidden;">
          ${innerOverlay}
          <div style="position:relative;z-index:1;">
            <div class="tag-airline" style="color:${t.accent};opacity:0.9;font-size:6px;">${t.airline}</div>
            ${t.sub ? `<div style="font-family:'Courier Prime',monospace;font-size:5px;letter-spacing:1px;opacity:0.55;color:${t.text};margin-bottom:2px;">${t.sub}</div>` : ''}
            <div class="tag-code" style="font-size:${Math.round(t.size * 0.42)}px;color:${t.text};line-height:0.95;">${t.code}</div>
            <div class="tag-city" style="color:${t.text};opacity:0.7;">${t.city}</div>
            <div style="display:flex;justify-content:space-between;margin-top:6px;font-family:'Courier Prime',monospace;font-size:6px;opacity:0.45;color:${t.text};">
              <span>${tagNum}</span>
              <span>▸ DEST</span>
            </div>
          </div>
        </div>
      `;
      frag.appendChild(tagEl);
    });

    wall.appendChild(frag);
  }

  /* ---------- Bottom ticker ---------- */
  function renderTicker() {
    const track = document.getElementById('tickerTrack');
    if (!track) return;
    const flights = [
      'SWA2215 · DEN→LAX · 17,000 FT · 447 KTS',
      'BAW210 · LHR→LAX · 38,000 FT · 521 KTS',
      'SWA3746 · ABQ→LAX · 28,500 FT · 468 KTS',
      'UAL889 · ORD→SFO · 35,000 FT · 510 KTS',
      'DAL447 · JFK→MIA · 32,000 FT · 496 KTS',
      'AAL100 · LAX→LHR · 40,000 FT · 538 KTS',
    ];
    const frag = document.createDocumentFragment();
    [...flights, ...flights].forEach((f) => {
      const item = document.createElement('div');
      item.className = 'ticker-item';
      const [flightId, ...rest] = f.split(' · ');
      item.innerHTML = `<span>${flightId}</span> ${rest.join(' · ')}`;
      frag.appendChild(item);
    });
    track.appendChild(frag);
  }

  /* ---------- Simulated 64x32 LED departure board ---------- */
  function setupLEDBoard() {
    const canvas = document.getElementById('led-canvas');
    if (!canvas) return;

    const DOT = 7, GAP = 1, PITCH = DOT + GAP;
    const COLS = 64, ROWS = 32;

    canvas.width = COLS * PITCH;
    canvas.height = ROWS * PITCH;

    const ctx = canvas.getContext('2d');
    let buf = new Array(COLS * ROWS).fill(null);

    const FONT = {
      ' ': [0, 0, 0, 0, 0], '>': [4, 2, 1, 2, 4],
      A: [2, 5, 7, 5, 5], B: [6, 5, 6, 5, 6], C: [3, 4, 4, 4, 3], D: [6, 5, 5, 5, 6],
      E: [7, 4, 6, 4, 7], F: [7, 4, 6, 4, 4], G: [3, 4, 5, 5, 3], H: [5, 5, 7, 5, 5],
      I: [7, 2, 2, 2, 7], J: [1, 1, 1, 5, 3], K: [5, 5, 6, 5, 5], L: [4, 4, 4, 4, 7],
      M: [5, 7, 5, 5, 5], N: [5, 7, 7, 5, 5], O: [2, 5, 5, 5, 2], P: [6, 5, 6, 4, 4],
      Q: [2, 5, 5, 7, 1], R: [6, 5, 6, 5, 5], S: [3, 4, 2, 1, 6], T: [7, 2, 2, 2, 2],
      U: [5, 5, 5, 5, 3], V: [5, 5, 5, 2, 2], W: [5, 5, 5, 7, 5], X: [5, 5, 2, 5, 5],
      Y: [5, 5, 2, 2, 2], Z: [7, 1, 2, 4, 7],
      0: [2, 5, 5, 5, 2], 1: [6, 2, 2, 2, 7], 2: [6, 1, 2, 4, 7], 3: [6, 1, 3, 1, 6],
      4: [5, 5, 7, 1, 1], 5: [7, 4, 6, 1, 6], 6: [2, 4, 6, 5, 2], 7: [7, 1, 2, 2, 2],
      8: [2, 5, 2, 5, 2], 9: [2, 5, 3, 1, 2],
      ':': [0, 2, 0, 2, 0], '-': [0, 0, 7, 0, 0], '.': [0, 0, 0, 0, 2],
    };

    const px = (c, r, color, glow) => {
      if (c >= 0 && c < COLS && r >= 0 && r < ROWS) buf[r * COLS + c] = { color, glow };
    };
    const hline = (c0, r, len, color, glow) => {
      for (let i = 0; i < len; i++) px(c0 + i, r, color, glow);
    };
    const vline = (c, r0, r1, color, glow) => {
      for (let r = r0; r <= r1; r++) px(c, r, color, glow);
    };
    const drawChar = (ch, sc, sr, color, glow) => {
      const bm = FONT[ch.toUpperCase()] || FONT[' '];
      for (let r = 0; r < 5; r++) {
        const row = bm[r];
        for (let b = 0; b < 3; b++) {
          if ((row >> (2 - b)) & 1) px(sc + b, sr + r, color, glow);
        }
      }
      return sc + 4;
    };
    const drawStr = (str, sc, sr, color, glow) => {
      let col = sc;
      for (const ch of str) col = drawChar(ch, col, sr, color, glow);
    };

    function drawFrame() {
      ctx.fillStyle = '#020204';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      for (let r = 0; r < ROWS; r++) {
        for (let c = 0; c < COLS; c++) {
          ctx.fillStyle = '#0a0a12';
          ctx.beginPath();
          ctx.arc(c * PITCH + PITCH / 2, r * PITCH + PITCH / 2, DOT / 2, 0, Math.PI * 2);
          ctx.fill();
        }
      }
      for (let r = 0; r < ROWS; r++) {
        for (let c = 0; c < COLS; c++) {
          const p = buf[r * COLS + c];
          if (!p) continue;
          ctx.save();
          ctx.shadowBlur = 8;
          ctx.shadowColor = p.glow;
          ctx.fillStyle = p.color;
          ctx.beginPath();
          ctx.arc(c * PITCH + PITCH / 2, r * PITCH + PITCH / 2, DOT / 2, 0, Math.PI * 2);
          ctx.fill();
          ctx.restore();
        }
      }
    }

    const cityPool = ['LAX', 'HNL', 'FRA', 'LHR', 'SFO', 'JFK', 'MIA', 'SEA', 'DEN', 'BOS', 'DFW', 'PHX', 'MSP', 'DTW', 'ATL', 'PDX', 'SLC', 'IAH', 'EWR', 'MCO'];
    const statusPool = [
      { st: 'SCHED', sc: '#4dff88', sg: '#00dd44' },
      { st: 'SCHED', sc: '#4dff88', sg: '#00dd44' },
      { st: 'SCHED', sc: '#4dff88', sg: '#00dd44' },
      { st: 'BOARD', sc: '#e8c13a', sg: '#bb8800', blink: true },
      { st: 'DELAY', sc: '#ff5566', sg: '#dd0022' },
      { st: 'CLXD', sc: '#ff2244', sg: '#aa0011' },
    ];

    const fmtTime = (d) =>
      String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');

    const makeFlight = (t, destCode) => {
      const s = statusPool[Math.floor(Math.random() * statusPool.length)];
      return { dest: destCode, time: t, timeStr: fmtTime(t), st: s.st, sc: s.sc, sg: s.sg, blink: s.blink };
    };

    let poolIdx = Math.floor(Math.random() * cityPool.length);
    const flightQueue = [];
    let nextT = new Date(Date.now() + 2 * 60000);
    nextT.setSeconds(0, 0);
    for (let i = 0; i < 4; i++) {
      const f = makeFlight(new Date(nextT), cityPool[poolIdx++ % cityPool.length]);
      if (i === 1) Object.assign(f, { st: 'BOARD', sc: '#e8c13a', sg: '#bb8800', blink: true });
      flightQueue.push(f);
      nextT = new Date(nextT.getTime() + (7 + Math.floor(Math.random() * 12)) * 60000);
    }

    let flipping = false;
    let blinkOn = true;

    function render() {
      buf = new Array(COLS * ROWS).fill(null);

      drawStr('ORD', 0, 0, '#ffffff', '#aaaaaa');
      drawStr('DEPT', 16, 0, '#2a3a2a', '#111111');
      const now = new Date();
      const hh = String(now.getHours()).padStart(2, '0');
      const mm = String(now.getMinutes()).padStart(2, '0');
      drawStr(`${hh}:${mm}`, 44, 0, '#e8c13a', '#aa8800');

      hline(0, 5, 64, '#5a4400', '#332200');
      hline(0, 6, 64, '#2a2000', '#110000');
      vline(12, 7, 31, '#182818', '#000');
      vline(34, 7, 31, '#182818', '#000');

      const rowStarts = [7, 13, 19, 25];
      flightQueue.forEach((d, i) => {
        const tr = rowStarts[i];
        if (!tr) return;
        const dim = flipping && i === 0;
        const alpha = dim ? '#333333' : '#ffffff';
        const aglow = dim ? '#111111' : '#cccccc';
        drawStr(d.dest, 0, tr, alpha, aglow);
        drawStr(d.timeStr, 14, tr, dim ? '#334466' : '#88aaff', dim ? '#111' : '#3355cc');
        if (!d.blink || blinkOn) drawStr(d.st, 36, tr, dim ? '#333' : d.sc, dim ? '#111' : d.sg);
        if (i < 3) hline(0, tr + 6, 64, '#0a100a', '#000');
      });

      drawFrame();
    }

    function checkAndShift() {
      if (flightQueue[0] && flightQueue[0].time.getTime() < Date.now()) {
        flipping = true;
        setTimeout(() => { flipping = false; render(); }, 500);
        flightQueue.shift();
        const last = flightQueue[flightQueue.length - 1];
        const gap = (7 + Math.floor(Math.random() * 13)) * 60000;
        const newT = new Date(last.time.getTime() + gap);
        flightQueue.push(makeFlight(newT, cityPool[poolIdx++ % cityPool.length]));
        render();
      }
    }

    render();
    // Respect reduced-motion: still show the board but skip the blink animation.
    if (!prefersReducedMotion) {
      setInterval(() => { blinkOn = !blinkOn; render(); }, 650);
    }
    setTimeout(() => {
      checkAndShift();
      setInterval(checkAndShift, 30000);
    }, 8000);
    setInterval(render, 60000);
  }
})();
